import React from "react";
import PrimaryButton from "../../components/PrimaryButton";
import { Card, Col, Form, Row, Spinner } from "react-bootstrap";
import InputField from "../../components/InputField";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import Loader from "../../components/Loader";
import i18n from "../../constants/Strings";
import useReplenishmentMailViewController from "../../viewControllers/ReplenishmentViewControllers/ReplenishmentMailViewController";


const ReplenishmentMail = () => {

    const {
        handleSubmit,
        values,
        emailData,
        loading,
        submitLoading,
        handleChange,
        ownStoreEmailEditState,
        setOwnStoreEmailEditState,
        warehouseEmailEditState,
        setWarehouseEmailEditState,
        ecomPlatformEmailEditState,
        setEcomPlatformEmailEditState,
        watsonStoreEmailEditState,
        setWatsonStoreEmailEditState,
        touched,
        errors,
    } = useReplenishmentMailViewController()

    const text = {
        pageHeading: i18n.t('replenishment.replenishmentMail.pageHeading'),
        ownStoreEmail: i18n.t('replenishment.replenishmentMail.ownStoreEmail'),
        ecomPlatformEmail: i18n.t('replenishment.replenishmentMail.ecomPlatformEmail'),
        watsonStoreEmail: i18n.t('replenishment.replenishmentMail.watsonStoreEmail'),
        warehouseEmail: i18n.t('replenishment.replenishmentMail.warehouseEmail'),
        submitBtn: i18n.t('replenishment.replenishmentMail.submitBtn'),

    }

    return (
        <>
            {loading ? <Loader /> : (
                <div className="container-fluid mt-5">
                    <div className="smb-4">
                        <div className="card-header py-3">
                            <h6 className="m-0 font-weight-bold txt-primary">
                                {text.pageHeading}
                            </h6>
                        </div>
                        <Card style={{ width: "100%", height: "500px" }}>
                            <Form onSubmit={handleSubmit} className="mt-4 mb-4 px-4">
                                <Row>
                                    <Col className="col-lg-6">
                                        <Row>
                                            <Col className="col-lg-4 mt-3">
                                                <p>
                                                    {text.ownStoreEmail} <span style={{ color: "red" }}>*</span>:{" "}
                                                </p>
                                            </Col>
                                            <Col className="col-lg-8">
                                                <InputField
                                                    type="email"
                                                    value={values?.ownStoreEmail}
                                                    disabled={ownStoreEmailEditState}
                                                    onChange={handleChange("ownStoreEmail")}
                                                    name="ownStoreEmail"
                                                    errors={touched?.ownStoreEmail && errors?.ownStoreEmail}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    {emailData?.own_store_email !== null ?
                                        <Col className="col-lg-1">
                                            {ownStoreEmailEditState === false ? (
                                                <div
                                                    className="mt-2 cursor-pointer px-1"
                                                    onClick={() => setOwnStoreEmailEditState(true)}
                                                >
                                                    <CloseIcon fontSize="large" />
                                                </div>
                                            ) : (
                                                <div
                                                    className="mt-2 cursor-pointer px-1"
                                                    onClick={() => setOwnStoreEmailEditState(false)}
                                                >
                                                    <EditIcon />
                                                </div>
                                            )}
                                        </Col>
                                        : null}
                                </Row>
                                <Row>
                                    <Col className="col-lg-6">
                                        <Row>
                                            <Col className="col-lg-4 mt-3">
                                                <p>
                                                    {text.ecomPlatformEmail} <span style={{ color: "red" }}>*</span>:{" "}
                                                </p>
                                            </Col>
                                            <Col className="col-lg-8">
                                                <InputField
                                                    type="email"
                                                    value={values?.ecomPlatformEmail}
                                                    disabled={ecomPlatformEmailEditState}
                                                    onChange={handleChange("ecomPlatformEmail")}
                                                    name="ecomPlatformEmail"
                                                    errors={touched?.ecomPlatformEmail && errors?.ecomPlatformEmail}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    {emailData?.ecom_platform_email !== null ?
                                        <Col className="col-lg-1">
                                            {ecomPlatformEmailEditState === false ? (
                                                <div
                                                    className="mt-2 cursor-pointer px-1"
                                                    onClick={() => setEcomPlatformEmailEditState(true)}
                                                >
                                                    <CloseIcon fontSize="large" />
                                                </div>
                                            ) : (
                                                <div
                                                    className="mt-2 cursor-pointer px-1"
                                                    onClick={() => setEcomPlatformEmailEditState(false)}
                                                >
                                                    <EditIcon />
                                                </div>
                                            )}
                                        </Col>
                                        : null}
                                </Row>
                                <Row>
                                    <Col className="col-lg-6">
                                        <Row>
                                            <Col className="col-lg-4 mt-3">
                                                <p>
                                                    {text.watsonStoreEmail} <span style={{ color: "red" }}>*</span>:{" "}
                                                </p>
                                            </Col>
                                            <Col className="col-lg-8">
                                                <InputField
                                                    type="email"
                                                    disabled={watsonStoreEmailEditState}
                                                    value={values?.watsonStoreEmail}
                                                    onChange={handleChange("watsonStoreEmail")}
                                                    name="watsonStoreEmail"
                                                    errors={touched?.watsonStoreEmail && errors?.watsonStoreEmail}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    {emailData?.watson_store_email !== null ?
                                        <Col className="col-lg-1">
                                            {watsonStoreEmailEditState === false ? (
                                                <div
                                                    className="mt-2 cursor-pointer px-1"
                                                    onClick={() => setWatsonStoreEmailEditState(true)}
                                                >
                                                    <CloseIcon fontSize="large" />
                                                </div>
                                            ) : (
                                                <div
                                                    className="mt-2 cursor-pointer px-1"
                                                    onClick={() => setWatsonStoreEmailEditState(false)}
                                                >
                                                    <EditIcon />
                                                </div>
                                            )}
                                        </Col>
                                        : null}
                                </Row>
                                <Row>
                                    <Col className="col-lg-6">
                                        <Row>
                                            <Col className="col-lg-4 mt-3">
                                                <p>
                                                    {text.warehouseEmail} <span style={{ color: "red" }}>*</span>:{" "}
                                                </p>
                                            </Col>
                                            <Col className="col-lg-8">
                                                <InputField
                                                    type="email"
                                                    disabled={warehouseEmailEditState}
                                                    value={values?.warehouseEmail}
                                                    onChange={handleChange("warehouseEmail")}
                                                    name="warehouseEmail"
                                                    errors={touched?.warehouseEmail && errors?.warehouseEmail}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    {emailData?.warehouse_email !== null ?
                                        <Col className="col-lg-1">
                                            {warehouseEmailEditState === false ? (
                                                <div
                                                    className="mt-2 cursor-pointer px-1"
                                                    onClick={() => setWarehouseEmailEditState(true)}
                                                >
                                                    <CloseIcon fontSize="large" />
                                                </div>
                                            ) : (
                                                <div
                                                    className="mt-2 cursor-pointer px-1"
                                                    onClick={() => setWarehouseEmailEditState(false)}
                                                >
                                                    <EditIcon />
                                                </div>
                                            )}
                                        </Col>
                                        : null}
                                </Row>

                                <div className="d-flex">
                                    {submitLoading ?  <Spinner /> : (
                                    <>
                                        <PrimaryButton
                                            type="submit"
                                            text={text.submitBtn}
                                            className="width-auto save-btn "
                                        />
                                    </>
                                    )}
                                </div>
                            </Form>
                        </Card>
                    </div>
                </div>
            )}
        </>
    );
};

export default ReplenishmentMail;

